//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  props: {},
  data() {
    return {
        formData:{
            postcode:'',
            act:'load'
        },
        status:false
    }
  },
  created() {
    this.load()
  },
  computed: {
    ...mapState(['data','postcode']),
  },
  methods: {
    submitConfirm() {
      let that = this
      this.$validator.validateAll().then(function(success) {
        if (!success) return;
        that._ajax.post_form('/common/ajax/postcode', that.formData, that).then(res => {
          if (res !== false && res.latitude) {
                that._func.dataStorage('position', res)
                that._func.dataStorage('leader', '__null__')
                that.load()
            }
        })
      })
    },
    getNavigator(){
        let that = this
        let position = that._func.dataStorage('position')
        if(!position.latitude){
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(position => {
                    that._func.dataStorage('position', {
                      latitude: position.coords.latitude,
                      longitude: position.coords.longitude,
                    })
                    resolve(1)
                }, err => {
                    resolve(2)
                }
               );
            })
        }else{
            return new Promise((resolve, reject) => {
                resolve(1)
            })
        }
    },
    onClose(){
        this.$store.commit('G_POSTCODE', '')
    },
    resetForm(field) {
      this.formData[field] = ''
    },
    load(){
        let that = this
        Promise.all([that.getNavigator()]).then((rs) => {
            Promise.all([that._maps.setUserDistance(that,that.data.leader.url)]).then((rf) => {
                if(rf[0] == 'post_code'){
                    if(that.postcode != null){
                        that.$store.commit('G_POSTCODE', 1)
                    }
                }else if(rf[0] == 'close'){
                    that.$store.commit('G_POSTCODE', '')
                }else if(rf[0] == 'leader_emp'){
                    that.$store.commit('G_POSTCODE', '')
                }
            })
        })
    }
  }
}

